import {Record as record, Set as set} from 'immutable';

const ContactOwnerFormRecord = record(
    {
        firstName: '',
        lastName: '',
        countryCode: 1,
        countryName: 'us',
        phoneNumber: '',
        emailAddress: '',
        message: '',
        unitNumber: '',
        touched: set(),
        invalid: set(),
        scrollTop: false,
        termsAndConditionsAgreed: false,
        newsSubscribed: false,
        isFormValid: true
    },
    'ContactOwnerFormRecord'
);

export default ContactOwnerFormRecord;
export {ContactOwnerFormRecord};
